import styled from "styled-components";
import { Loader } from "./Icons";

export const Loading = styled(Loader).attrs({
  size: 24,
  className: "icon-spin",
})``;
